export default __webpack_public_path__ + "static/media/model-x.95cc2e6d.jpeg";